<template>
    <div>
    <span class="ml-3" @click.native.stop>

        <span class="proposta-lote-maior-desconto" @click.stop.prevent>Desconto Total:&nbsp;</span>
        <v-tooltip top @click.native.stop>
            <a slot="activator" class="link-icone-mensagem">
                <v-icon color="orange" size="15px" left class="ml-1 icone-informacao">fas fa-info</v-icon>
            </a>
            O desconto total do lote será aplicado sobre cada item do mesmo.
        </v-tooltip>
        <v-chip color="#e8e8e8" class="money-chip ml-2 pa-0" outlined label>
            <az-money v-model="lote.totalUnitario"
                      placeholder="Insira desconto"
                      :name="'descontoTotal' + lote.loteId"
                      :maxLength="18"
                      :required="true"
                      :prefix="prefix"
                      :suffix="suffix"
                      v-validate="'required'"
                      class="alinhar-direita money-input"
                      :showClearButton="false"
                      :disabled="propostaEnviada"
                      @click.native.stop
                      :precision="casasDecimais"
                      @blur="enviarDescontoLote($event, lote)"
            />
        </v-chip>
    </span>

    </div>
</template>

<script>

export default {
    name: 'LoteMaiorDesconto',
    props:{
        lote: {
            type: Object
        },
        aceitaValorZero:{
            type: Boolean,
            default: null
        },
        casasDecimais:{
            type: Number
        },
        criterioJulgamento:{
            type: String
        },
        prefix:{
            type: String
        },
        suffix:{
            type: String
        },
        propostaEnviada:{
            type: Boolean,
            default: false
        }
    },
    methods:{
        enviarDescontoLote(desconto, lote) {
            lote.totalUnitario = desconto
            this.verificarValor(lote)
            this.$emit('salvarLote', lote)
        },
        verificarValor(lote) {
            if(!this.aceitaValorZero && lote.totalUnitario !== null && lote.totalUnitario <= 0)
                throw new Error('O Desconto da proposta deve ser maior que zero')
        }
    }
}

</script>

<style lang="stylus">

    .icone-negociacao
        font-size 22px
        margin-bottom -2px
        margin-right 5px

    .icone-informacao
        padding-bottom 2px
        margin 0 2px 0 0

    .negociacao-solicitada
        padding 0
        margin 0
        font-weight bold
        font-size 15x
        color var(--v-primary-base) !important

    .money-chip
        padding 0
        margin 0

    .money-input
        width 120px
        position relative

    .link-icone-mensagem
        width 10px
        padding 0

    .botao-aceitar
        width 25px
        height 25px
        margin 0 0 0 0

    .botao-rejeitar
        width 25px
        height 25px
        margin 0 0 0 0

</style>
